import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import BannerFeaturedCategoriesProducts from '../components/BannerFeaturedCategoriesProducts';
import ModularBlocks from '../components/ModularBlocks';
import { orderFeaturedProducts } from '../utils';

const DefaultPageTemplate = ({
  data: {
    datoCmsHome: {
      seoMetaTags,
      title,
      bannerHeading,
      bannerLinks,
      bannerImage,
      bannerCtas,
      featuredProductCategoriesHeading,
      featuredProductCategories,
      featuredProductsHeading,
      modularBlocks,
    },
    allShopifyProduct: { nodes: featuredProducts },
  },
  pageContext: { featuredProducts: featuredProductsOrder },
}) => {
  return (
    <Layout seo={seoMetaTags}>
      <main>
        <BannerFeaturedCategoriesProducts
          banner={{
            heading: bannerHeading || title,
            links: bannerLinks,
            image: bannerImage,
            ctas: bannerCtas,
          }}
          featuredCategories={{
            heading: featuredProductCategoriesHeading,
            items: featuredProductCategories,
          }}
          featuredProducts={{
            heading: featuredProductsHeading,
            items: orderFeaturedProducts(
              featuredProducts,
              featuredProductsOrder,
            ),
          }}
        />
        <ModularBlocks items={modularBlocks} />
      </main>
    </Layout>
  );
};

export const HomePageTemplateQuery = graphql`
  query HomePageTemplateQuery($featuredProducts: [String]!) {
    datoCmsHome {
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
      title
      bannerHeading
      bannerLinks {
        text
        pageUrl {
          ...LinkFragment
        }
      }
      bannerImage {
        gatsbyImageData(
          width: 1100
          height: 540
          imgixParams: { w: "1100", h: "540" }
        )
        alt
      }
      bannerCtas {
        heading
        text
        link {
          text
          pageUrl {
            ...LinkFragment
          }
        }
        image {
          gatsbyImageData(
            width: 200
            height: 200
            imgixParams: { w: "200", h: "200" }
          )
          alt
        }
      }
      featuredProductCategoriesHeading
      featuredProductCategories {
        ...ProductCategoryCardFragment
      }
      featuredProductsHeading
      modularBlocks {
        ...BackgroundImageCtaModularBlockFragment
        ...ContentModularBlockFragment
        ...FeaturedLogosModularBlockFragment
        ...FeaturedProductCategoriesModularBlockFragment
        ...IconStepsModularBlockFragment
        ...ImageContentCardsModularBlockFragment
        ...InternalVideoContentModularBlockFragment
        ...UpcomingEventsModularBlockFragment
      }
    }
    allShopifyProduct(filter: { handle: { in: $featuredProducts } }) {
      nodes {
        ...ProductCardFragment
      }
    }
  }
`;

export default DefaultPageTemplate;
